import React from 'react'
import { Popconfirm } from 'antd'
import { EditOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons'

const dropdownFolderMenu = (meta, props) => {
  const onRemove = () => props.onDeleteFolder(meta)

  const menu = []

  if (props.allowZip) {
    menu.push({
      label: 'Download as ZIP',
      key: 'download_folder',
      icon: <DownloadOutlined />
    })
  }

  if (props.allowRename) {
    menu.push({
      label: 'Rename',
      key: 'rename',
      icon: <EditOutlined />
    })
  }

  if (props.allowDelete) {
    menu.push({ type: 'divider' })
    menu.push({
      key: 'remove_folder',
      icon: <DeleteOutlined />,
      label: (
        <Popconfirm title='Are you sure?' onConfirm={onRemove} okText='Yes' cancelText='No'>
          Remove
        </Popconfirm>
      ),
      danger: true
    })
  }

  return menu
}

const dropdownFileMenu = (meta, props) => {
  const onRemove = () => props.onDeleteFile(meta)

  const menu = [
    {
      label: 'Download',
      key: 'download_file',
      icon: <DownloadOutlined />
    }
  ]

  if (props.allowRename) {
    menu.push({
      label: 'Rename',
      key: 'rename',
      icon: <EditOutlined />
    })
  }

  if (props.allowDelete) {
    menu.push({ type: 'divider' })
    menu.push({
      key: 'remove_file',
      icon: <DeleteOutlined />,
      danger: true,
      label: (
        <Popconfirm title='Are you sure?' onConfirm={onRemove} okText='Yes' cancelText='No'>
          Remove
        </Popconfirm>
      )
    })
  }

  return menu
}

export const dropdownObjectMenu = (meta, props) => {
  if (meta?.type === 'folder') {
    return dropdownFolderMenu(meta, props)
  }

  if (meta?.type === 'file') {
    return dropdownFileMenu(meta, props)
  }

  return []
}
